"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});



/* メガメニュー制御（hover制御を厳密化） */
document.addEventListener('DOMContentLoaded', function() {
  const megaMenuBtn = document.querySelector('.megaMenu__btn');
  const megaMenuContainer = document.querySelector('.megaMenu__container');
  const megaMenuLinks = document.querySelectorAll('.megaMenu__link');
  const megaMenuContents = document.querySelectorAll('.megeMenu__content');
  const mainElement = document.querySelector('main');

  let isMenuVisible = false; // メニュー状態を管理

  if (megaMenuBtn && megaMenuContainer) {
    // メガメニューボタンのホバー制御のみ
    megaMenuBtn.addEventListener('mouseenter', function() {
      isMenuVisible = true;
      megaMenuContainer.classList.add('is-visible');
      if (mainElement) {
        mainElement.classList.add('is-active');
      }
    });

    megaMenuBtn.addEventListener('mouseleave', function() {
      // ボタンから離れた時、少し遅延してコンテナにいるかチェック
      setTimeout(() => {
        if (!megaMenuContainer.matches(':hover')) {
          hideMenu();
        }
      }, 50);
    });

    // メガメニューコンテナの制御
    megaMenuContainer.addEventListener('mouseenter', function() {
      // ボタンからコンテナに移動した場合は表示を維持
      isMenuVisible = true;
    });

    megaMenuContainer.addEventListener('mouseleave', function() {
      // コンテナから離れたら即座に非表示
      hideMenu();
    });

    // メニューを非表示にする関数
    function hideMenu() {
      isMenuVisible = false;
      megaMenuContainer.classList.remove('is-visible');
      if (mainElement) {
        mainElement.classList.remove('is-active');
      }

      // 最初の要素にリセット
      resetToFirst();
    }

    // 最初の要素をアクティブにする関数
    function resetToFirst() {
      megaMenuLinks.forEach(l => l.classList.remove('is-active'));
      megaMenuContents.forEach(content => content.classList.remove('is-active'));

      if (megaMenuLinks[0]) {
        megaMenuLinks[0].classList.add('is-active');
      }
      if (megaMenuContents[0]) {
        megaMenuContents[0].classList.add('is-active');
      }
    }
  }

  // メガメニューリンクのホバー効果とコンテンツ切り替え
  megaMenuLinks.forEach((link, index) => {
    link.addEventListener('mouseenter', function() {
      // メニューが表示されている時のみ動作
      if (isMenuVisible) {
        // すべてのリンクからis-activeを削除
        megaMenuLinks.forEach(l => l.classList.remove('is-active'));
        // 現在のリンクにis-activeを追加
        link.classList.add('is-active');

        // すべてのコンテンツからis-activeを削除
        megaMenuContents.forEach(content => content.classList.remove('is-active'));
        // 対応するコンテンツにis-activeを追加
        if (megaMenuContents[index]) {
          megaMenuContents[index].classList.add('is-active');
        }
      }
    });
  });
});



/* ----- telリンクPC無効 ----- */
// より厳密なPC判定（タブレットも考慮）
function isMobileDevice() {
  // モバイル・タブレットデバイスのパターン
  const mobilePatterns = [
    /iPhone/i,
    /iPad/i,
    /Android/i,
    /Windows Phone/i,
    /BlackBerry/i,
    /Opera Mini/i,
    /Mobile/i,
    /Tablet/i
  ];

  return mobilePatterns.some(pattern => pattern.test(navigator.userAgent));
}

// タッチデバイス判定も追加
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

function disableTelLinksOnDesktop() {
  const isDesktop = !isMobileDevice() && !isTouchDevice();

  if (isDesktop) {
    // 電話番号リンクを全て取得
    const telLinks = document.querySelectorAll('a[href^="tel:"], a.tel-link');

    telLinks.forEach(link => {
      // 元のhrefを保存（後で復元する場合に備えて）
      link.dataset.originalHref = link.href;

      // リンクを無効化
      link.removeAttribute('href');

      // スタイルを調整
      Object.assign(link.style, {
        pointerEvents: 'none',
        textDecoration: 'none',
        color: 'inherit',
        cursor: 'default'
      });

      // アクセシビリティのため、無効化されていることを示す
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('title', 'デスクトップでは電話をかけられません');
    });

    console.log(`${telLinks.length}個の電話番号リンクを無効化しました`);
  }
}

// DOMが読み込まれた後に実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', disableTelLinksOnDesktop);
} else {
  disableTelLinksOnDesktop();
}

// 動的に追加されるリンクにも対応する場合
function observeTelLinks() {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const newTelLinks = node.querySelectorAll('a[href^="tel:"], a.tel-link');
          if (newTelLinks.length > 0) {
            disableTelLinksOnDesktop();
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// 動的コンテンツの監視を開始（必要に応じて）
// observeTelLinks();
/* ----- telリンクPC無効ここまで ----- */


/* ----- qaアコーディオン ----- */
$(".qa__question").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

/* ----- サイドバーアコーディオン ----- */
$(".sidebar__article").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

/* ----- メニューアコーディオン ----- */
$(".menu__btn").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});


/* ----- ソートアコーディオン ----- */
$(".sort__container").on("click", function(e) {
  // フィルターボタンがクリックされた場合は何もしない
  if ($(e.target).hasClass('sort__button') || $(e.target).closest('.sort__button').length) {
    return;
  }

  $(this).find(".sort__content").slideToggle();
  $(this).toggleClass("is-active");
});



/* ----- フェードイン（Safari最適化版） ----- */
$(function () {
    let ticking = false;
    let windowHeight = $(window).height();
    let $fadeElements = $(".fade");
    let isInitialLoad = true;
    let hasScrolled = false;

    // ウィンドウリサイズ時の高さ更新（スマホの向き変更対応）
    $(window).on('resize orientationchange', function() {
        windowHeight = $(window).height();
        // Safari向けの遅延実行
        setTimeout(function() {
            if (hasScrolled) {
                checkFadeElements();
            }
        }, 100);
    });

    // フェードイン判定の最適化された関数
    function checkFadeElements() {
        const scroll = $(window).scrollTop();
        const offset = 100; // 100px手前でトリガー

        $fadeElements.each(function () {
            const $this = $(this);

            // 既にアクティブな要素はスキップ
            if ($this.hasClass("is-active")) {
                return;
            }

            const targetPosition = $this.offset().top;
            const triggerPoint = targetPosition - windowHeight + offset;

            if (scroll > triggerPoint) {
                // requestAnimationFrameで滑らかなアニメーション
                requestAnimationFrame(function() {
                    $this.addClass("is-active");
                });

                // アクティブになった要素をjQueryオブジェクトから除外
                $fadeElements = $fadeElements.not($this);
            }
        });

        ticking = false;
    }

    // スクロールイベントの最適化（requestAnimationFrame使用）
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(checkFadeElements);
            ticking = true;
        }
    }

    // 初回スクロール検知
    function handleFirstScroll() {
        hasScrolled = true;
        isInitialLoad = false;
        checkFadeElements();
        // 一度だけ実行したらイベントを削除
        $(window).off('scroll.firstScroll');
    }

    // スクロールイベントの登録
    $(window).on('scroll', requestTick);

    // 初回スクロール専用イベント
    $(window).on('scroll.firstScroll', handleFirstScroll);

    // アンカーリンク付きの場合のみ初期チェック
    if (window.location.hash) {
        hasScrolled = true;
        isInitialLoad = false;
        // Safari向けに少し遅延して実行
        setTimeout(function() {
            checkFadeElements();
        }, 50);
    }

    // Intersection Observer対応ブラウザの場合はより効率的な実装に切り替え
    if ('IntersectionObserver' in window) {
        const observerOptions = {
            threshold: 0,
            rootMargin: '0px 0px -100px 0px'
        };

        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                // 初期表示時は無視（スクロールが発生してから有効化）
                if (isInitialLoad && !hasScrolled) {
                    return;
                }

                if (entry.isIntersecting) {
                    const $target = $(entry.target);
                    requestAnimationFrame(function() {
                        $target.addClass("is-active");
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        // .fadeクラスを持つ要素を監視
        $fadeElements.each(function() {
            if (!$(this).hasClass("is-active")) {
                observer.observe(this);
            }
        });
    }
});

/* ----- フェードインここまで ----- */





/* ----- fvスライダー ----- */
const fvSwiper = new Swiper('.fv__swiper', {
  effect: 'fade',
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  speed: 1000,
  fadeEffect: {
    crossFade: true,
  },
    // ページネーション設定追加
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    type: 'bullets', // 'bullets', 'fraction', 'progressbar'のいずれか
  },
});



/* ----- top-blog（完全確実バージョン） ----- */
document.addEventListener('DOMContentLoaded', function () {

  let swiperInstance = null;

  function setSlideWidth() {
    const slides = document.querySelectorAll('.topBlog__item');
    const isDesktop = window.innerWidth >= 768;

    slides.forEach((slide) => {
      if (isDesktop) {
        slide.style.width = '40.8rem';
        slide.style.minWidth = '40.8rem';
        slide.style.flexShrink = '0';
      } else {
        slide.style.width = '';
        slide.style.minWidth = '';
        slide.style.flexShrink = '';
      }
    });
  }

  function initSwiper() {
    const isDesktop = window.innerWidth >= 768;

    if (swiperInstance) {
      swiperInstance.destroy(true, true);
    }

    setSlideWidth();

    swiperInstance = new Swiper('.topBlog__slider', {
      slidesPerView: isDesktop ? 'auto' : 1,
      spaceBetween: 32,
      loop: true,
      slidesPerGroup: 1,
      speed: 400,
      autoplay: {
        delay: 5000, // 5秒ごとにスライド
        disableOnInteraction: false, // ユーザー操作後も自動再生を継続
      },

      navigation: {
        nextEl: '.topBlog__button.--next',
        prevEl: '.topBlog__button.--prev',
      },

      on: {
        init: function() {
          setSlideWidth();
        }
      }
    });
  }

  // 初期化
  initSwiper();

  // リサイズ時の再初期化
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      initSwiper();
    }, 300);
  });
});

function closeBanner() {
  document.querySelector('.banner').style.display = 'none';
}



/* ----- スムースクロール ----- */
document.addEventListener('DOMContentLoaded', function() {
  // 固定ヘッダー（固定しない場合は = 0）
  const headerElement = document.querySelector('header');
  const headerHeight = headerElement ? headerElement.offsetHeight : 0; // ヘッダーが存在しない場合は0に設定

  // スマホサイズの時の追加オフセット（必要に応じて調整）
  const mobileOffset = -10; // 10px 追加オフセット
  // PCサイズの時の追加オフセット（必要に応じて調整）
  const pcOffset = 0; // 5px 上に調整

  // ページ内のスムーススクロール
  const anchorLinks = document.querySelectorAll('a[href*="#"]');

  if (anchorLinks && anchorLinks.length > 0) {
    anchorLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const hash = e.currentTarget.hash;

        // ページトップへ("#"と"#top"）
        if (!hash || hash === '#top') {
          e.preventDefault();
          window.scrollTo({
            top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
            behavior: 'smooth',
          });
        }
        // アンカーへ
        else if (hash.slice(1)) {
          const target = document.getElementById(hash.slice(1));
          if (target) {
            e.preventDefault();
            let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

            // スマホサイズの場合の追加オフセット
            if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
              position += mobileOffset;
            } else {
              // PCサイズの場合の追加オフセット
              position += pcOffset;
            }

            window.scrollTo({
              top: position,
              behavior: "smooth",
            });

            // URLにハッシュを含める
            history.pushState(null, '', hash);
          }
        }
      });
    });
  }
});


/* ----- 施工画像スライダー ----- */
document.addEventListener('DOMContentLoaded', function() {
    // 車両画像スライダーが存在するかチェック
    const mainSwiperElement = document.querySelector('.main-swiper');
    const thumbsContainer = document.querySelector('.thumbs-swiper');

    if (!mainSwiperElement || !thumbsContainer) {
        // console.log('スライダー要素が見つかりません');
        return; // 要素が存在しない場合は処理を終了
    }

    // Swiperライブラリが読み込まれているかチェック
    if (typeof Swiper === 'undefined') {
        console.warn('Swiperライブラリが読み込まれていません');
        return;
    }

    // メインスライダーの初期化
    const mainSwiper = new Swiper('.main-swiper', {
        spaceBetween: 10,
        loop: false, // loopをfalseにして正確なインデックス管理
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        // ナビゲーションボタンを設定
        navigation: {
            nextEl: '#main-next',
            prevEl: '#main-prev',
        },
        // スライド変更時にサムネイルのアクティブ状態を更新
        on: {
            slideChange: function() {
                updateThumbnailActive(this.activeIndex);
                updateMainNavigation(this.activeIndex, this.slides.length);
            },
            init: function() {
                // 初期化時にナビゲーションボタンの状態を設定
                updateMainNavigation(this.activeIndex, this.slides.length);
            }
        }
    });

    // メインナビゲーションボタンの状態を更新
    function updateMainNavigation(activeIndex, totalSlides) {
        const prevBtn = document.getElementById('main-prev');
        const nextBtn = document.getElementById('main-next');

        if (prevBtn) {
            if (activeIndex === 0) {
                prevBtn.classList.add('swiper-button-disabled');
                prevBtn.disabled = true;
            } else {
                prevBtn.classList.remove('swiper-button-disabled');
                prevBtn.disabled = false;
            }
        }

        if (nextBtn) {
            if (activeIndex === totalSlides - 1) {
                nextBtn.classList.add('swiper-button-disabled');
                nextBtn.disabled = true;
            } else {
                nextBtn.classList.remove('swiper-button-disabled');
                nextBtn.disabled = false;
            }
        }
    }

    // サムネイル取得
    const thumbnails = document.querySelectorAll('.thumbs-swiper .swiper-slide');

    // 関数で表示件数を決定
    function getItemsPerPage() {
      return window.innerWidth <= 767 ? 9 : 15; // スマホ9件、PC15件
    }

    let itemsPerPage = getItemsPerPage();
    let currentPage = 0;
    let totalPages = Math.ceil(thumbnails.length / itemsPerPage);

    console.log(`サムネイル総数: ${thumbnails.length}, 総ページ数: ${totalPages}`);

    // ウィンドウリサイズで再計算
    window.addEventListener('resize', () => {
      const newItemsPerPage = getItemsPerPage();

      if (newItemsPerPage !== itemsPerPage) {
        itemsPerPage = newItemsPerPage;
        totalPages = Math.ceil(thumbnails.length / itemsPerPage);
        currentPage = 0;

        updateThumbnailDisplay();
        updatePaginationInfo();
      }
    });

    // ページネーション要素
    const prevBtn = document.getElementById('thumb-prev');
    const nextBtn = document.getElementById('thumb-next');
    const currentPageSpan = document.getElementById('current-page');
    const totalPagesSpan = document.getElementById('total-pages');

    // 初期設定
    updateThumbnailDisplay();
    updatePaginationInfo();

    // サムネイル表示更新
    function updateThumbnailDisplay() {
        thumbnails.forEach((thumb, index) => {
            const pageIndex = Math.floor(index / itemsPerPage);
            if (pageIndex === currentPage) {
                thumb.style.display = 'flex';
            } else {
                thumb.style.display = 'none';
            }
        });
    }

    // サムネイルのアクティブ状態を更新
    function updateThumbnailActive(activeIndex) {
        thumbnails.forEach((thumb, index) => {
            if (index === activeIndex) {
                thumb.classList.add('is-active');
            } else {
                thumb.classList.remove('is-active');
            }
        });
    }

    // ページネーション情報更新
    function updatePaginationInfo() {
        if (currentPageSpan && totalPagesSpan) {
            currentPageSpan.textContent = currentPage + 1;
            totalPagesSpan.textContent = totalPages;
        }

        if (prevBtn) {
            if (currentPage === 0) {
                prevBtn.classList.add('is-hidden');
            } else {
                prevBtn.classList.remove('is-hidden');
            }
        }

        if (nextBtn) {
            if (currentPage >= totalPages - 1) {
                nextBtn.classList.add('is-hidden');
            } else {
                nextBtn.classList.remove('is-hidden');
            }
        }

        if (prevBtn) {
            prevBtn.disabled = currentPage === 0;
        }
        if (nextBtn) {
            nextBtn.disabled = currentPage >= totalPages - 1;
        }

        // ページが1つしかない場合はナビゲーション自体を非表示
        const navigation = document.querySelector('.thumbnail-navigation');
        if (navigation) {
            if (totalPages <= 1) {
                navigation.style.display = 'none';
            } else {
                navigation.style.display = 'flex';
            }
        }
    }

    // サムネイルページネーション：前のページ
    if (prevBtn) {
        prevBtn.addEventListener('click', function() {
            if (currentPage > 0) {
                currentPage--;
                updateThumbnailDisplay();
                updatePaginationInfo();
            }
        });
    }

    // サムネイルページネーション：次のページ
    if (nextBtn) {
        nextBtn.addEventListener('click', function() {
            if (currentPage < totalPages - 1) {
                currentPage++;
                updateThumbnailDisplay();
                updatePaginationInfo();
            }
        });
    }

    // サムネイルクリックでメイン画像変更
    thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', function(e) {
            e.preventDefault(); // デフォルトの動作を防ぐ

            // console.log(`サムネイル ${index} がクリックされました`);

            // アクティブ状態を更新
            updateThumbnailActive(index);

            // メインスライダーを該当のスライドに移動
            if (mainSwiper) {
                mainSwiper.slideTo(index, 300); // 300msのアニメーション付きで移動
                // console.log(`メインスライダーをスライド ${index} に移動`);
            }

            // クリックされたサムネイルが表示されているページに移動
            const targetPage = Math.floor(index / itemsPerPage);
            if (targetPage !== currentPage) {
                currentPage = targetPage;
                updateThumbnailDisplay();
                updatePaginationInfo();
            }
        });
    });

    // 最初のサムネイルをアクティブに
    if (thumbnails.length > 0) {
        updateThumbnailActive(0);
    }

    // ウィンドウリサイズ時の調整
    window.addEventListener('resize', function() {
        if (mainSwiper) {
            mainSwiper.update();
        }
    });

    // // デバッグ用：メインスライダーの情報を出力
    // console.log('メインスライダー初期化完了');
    // console.log('スライド数:', mainSwiper.slides.length);
});
/* ----- 施工画像スライダーここまで ----- */








/* ----- 施工事例フィルタリング（Ajax版・OR条件） ----- */
jQuery(document).ready(function($) {
    // 施工事例ページでのみ実行
    if ($('#case-items-container').length === 0) return;

    let currentFilters = {
        category: '',
        tag: '',
        paged: 1
    };

    // フィルターが適用されているかどうかの判定
    function hasActiveFilters() {
        return currentFilters.category !== '' || currentFilters.tag !== '';
    }

    // フィルターボタンのクリックイベント
    $(document).on('click', '.sort__button', function(e) {
        e.preventDefault();

        const filterType = $(this).data('type');
        const filterValue = $(this).data('filter');

        // デバッグ用
        console.log('クリックされたボタン:', $(this).text());
        console.log('フィルタータイプ:', filterType);
        console.log('フィルター値:', filterValue);

        // 全てのボタンのアクティブ状態をリセット
        $('.sort__button').removeClass('is-active');

        // クリックされたボタンをアクティブに
        $(this).addClass('is-active');

        // フィルター状態を更新（OR条件のため、どちらか一方のみ）
        if (filterValue === 'all') {
            // 「すべて」が選択された場合は両方リセット
            currentFilters.category = '';
            currentFilters.tag = '';
        } else {
            // URLエンコードされた値をデコード
            const decodedValue = decodeURIComponent(filterValue);

            if (filterType === 'category') {
                currentFilters.category = decodedValue;
                currentFilters.tag = ''; // タグをリセット
            } else if (filterType === 'tag') {
                currentFilters.tag = decodedValue;
                currentFilters.category = ''; // カテゴリをリセット
            }
        }

        // デバッグ用：フィルター状態を確認
        console.log('更新後のフィルター状態:', currentFilters);

        currentFilters.paged = 1; // ページをリセット
        filterCaseItems();
    });

    // Ajaxでフィルタリング実行
    function filterCaseItems() {
        $('#case-items-container').addClass('loading');

        // Ajax URLの設定
        const ajaxUrl = typeof ajax_object !== 'undefined' ? ajax_object.ajax_url : '/wp-admin/admin-ajax.php';

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'filter_case_items',
                category: currentFilters.category,
                tag: currentFilters.tag,
                paged: currentFilters.paged
            },
            success: function(response) {
                if (response.success) {
                    // コンテンツの更新
                    $('#case-items-container').html(response.content);

                    // ページネーションの更新
                    updatePagination(response.pagination);

                    // 件数表示があれば更新
                    if ($('#results-count').length) {
                        $('#results-count').text('全 ' + response.total + ' 件');
                    }

                    // フェードインを再適用
                    setTimeout(function() {
                        $('.case__item').addClass('fade is-active');
                    }, 100);

                    // コンソールに結果を表示
                    console.log('=== 施工事例フィルター結果 ===');
                    console.log('カテゴリ:', currentFilters.category || '指定なし');
                    console.log('タグ:', currentFilters.tag || '指定なし');
                    console.log('現在のページ:', currentFilters.paged);
                    console.log('該当総数:', response.total + '件');
                    console.log('送信したフィルター値:', {
                        category: currentFilters.category,
                        tag: currentFilters.tag
                    });
                    console.log('========================');
                } else {
                    // エラー時の処理
                    $('#case-items-container').html('<p class="no-results-message" style="text-align: center; padding: 40px 20px; color: #666;">条件に一致する施工事例が見つかりませんでした。</p>');
                    updatePagination('');
                }
                $('#case-items-container').removeClass('loading');
            },
            error: function(xhr, status, error) {
                console.error('Ajax Error:', error);
                console.error('Response Text:', xhr.responseText);
                console.error('Status:', status);
                console.error('Status Code:', xhr.status);
                alert('エラーが発生しました。コンソールを確認してください。');
                $('#case-items-container').removeClass('loading');
            }
        });
    }

    // ページネーションの更新
    function updatePagination(paginationHtml) {
        const paginationContainer = $('.pagination.navigation .nav-links');
        if (paginationContainer.length) {
            paginationContainer.html(paginationHtml || '');
        }

        // ページネーション全体の表示・非表示制御
        const pagination = $('.pagination.navigation');
        if (pagination.length) {
            if (paginationHtml && paginationHtml.trim() !== '') {
                pagination.show();
            } else {
                pagination.hide();
            }
        }
    }

    // ページネーションのクリックイベント
    $(document).on('click', '.pagination a', function(e) {
        // フィルターが適用されている場合のみAjaxを使用
        if (hasActiveFilters()) {
            e.preventDefault();

            // data-page属性からページ番号を取得
            const pageNum = $(this).data('page');
            if (pageNum) {
                currentFilters.paged = parseInt(pageNum);
            } else {
                // fallback: URLからページ番号を抽出
                const href = $(this).attr('href');
                if (href && href.includes('/page/')) {
                    const match = href.match(/\/page\/(\d+)/);
                    currentFilters.paged = match ? parseInt(match[1]) : 1;
                } else if (href && href.includes('paged=')) {
                    const match = href.match(/paged=(\d+)/);
                    currentFilters.paged = match ? parseInt(match[1]) : 1;
                } else {
                    currentFilters.paged = 1;
                }
            }

            filterCaseItems();

            // スクロール調整
            const caseSection = document.querySelector('.case');
            if (caseSection) {
                const headerElement = document.querySelector('header');
                const headerHeight = headerElement ? headerElement.offsetHeight : 0;
                const position = caseSection.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

                window.scrollTo({
                    top: position,
                    behavior: 'smooth'
                });
            }
        }
        // フィルターが適用されていない場合は通常のリンクとして動作
    });

    // 初期状態で「すべて」ボタンをアクティブに
    const firstAllButton = $('.sort__button[data-filter="all"]').first();
    if (firstAllButton.length) {
        firstAllButton.addClass('is-active');
    }

    // ローディング用のCSS（動的に追加）
    if (!$('#case-loading-styles').length) {
        $('head').append(`
            <style id="case-loading-styles">
                #case-items-container.loading {
                    opacity: 0.5;
                    pointer-events: none;
                    position: relative;
                }
                #case-items-container.loading::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 32px;
                    height: 32px;
                    margin: -16px 0 0 -16px;
                    border: 3px solid #f3f3f3;
                    border-top: 3px solid #3498db;
                    border-radius: 50%;
                    animation: case-loading-spin 1s linear infinite;
                }
                @keyframes case-loading-spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
        `);
    }
});
/* ----- 施工事例フィルタリング（Ajax版・OR条件）ここまで ----- */


/* ----- LINEbannerフッター下部で消える ----- */
function closeBanner() {
  document.querySelector('.banner').style.display = 'none';
}

// モバイル時のフッター検知でバナー非表示
function handleBannerVisibility() {
  if (window.innerWidth <= 767) {
    const banner = document.querySelector('.banner');
    const footer = document.querySelector('.footer__bottom');

    if (!banner || !footer) return;

    const footerRect = footer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // フッターが画面に表示されたらバナーを非表示
    if (footerRect.top <= windowHeight) {
      banner.classList.add('hidden');
    } else {
      banner.classList.remove('hidden');
    }
  }
}

// スクロールイベントとリサイズイベントにリスナーを追加
window.addEventListener('scroll', handleBannerVisibility);
window.addEventListener('resize', handleBannerVisibility);

// 初期実行
document.addEventListener('DOMContentLoaded', handleBannerVisibility);
/* ----- LINEbannerフッター下部で消えるここまで ----- */
